const viewModules = import.meta.glob("../views/**/*.js");

export function loadView(url) {
    const key = "../views/" + url + ".js";
    const loader = viewModules[key];

    if (!loader) {
        return Promise.reject({ requireModules: ["views/" + url] });
    }

    return loader()
        .then(function (mod) {
            return mod.default || mod;
        })
        .catch(function (err) {
            if (err && /Failed to fetch dynamically imported module/i.test(String(err.message || err))) {
                const reloadKey = "__chunk_reload_once__";
                if (!sessionStorage.getItem(reloadKey)) {
                    sessionStorage.setItem(reloadKey, "1");
                    const baseUrl = window.location.origin + window.location.pathname;
                    const query = "_v=" + Date.now();
                    const hash = window.location.hash || "";
                    window.location.replace(baseUrl + "?" + query + hash);
                    return;
                }
                sessionStorage.removeItem(reloadKey);
            }
            return Promise.reject({ requireModules: ["views/" + url] });
        });
}
